import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    name: '',
    email: '',
    userData: {},
    userDataLoading: false,
    userDataError: false,
    openTermsAndConditions: false,
    checkTermsAndConditions: false,
  },
  reducers: {
    setAuth: (state, action) => {
      state.name = action.payload.name;
      state.email = action.payload.email;
    },
    setUserDataLoading: (state, action) => {
      state.userDataLoading = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
      state.userDataLoading = false;
      state.userDataError = null;
    },
    setUserDataError: (state, action) => {
      state.userDataError = action.payload;
      state.userDataLoading = false;
    },
    setTermsAndConditions: (state, action) => {
      state.openTermsAndConditions = action.payload;
    },
    setCheckTermsAndConditions: (state, action) => {
      state.checkTermsAndConditions = action.payload;
    },
  },
});

export const { setAuth, setUserData,setUserDataLoading,setUserDataError,setTermsAndConditions,setCheckTermsAndConditions } = authSlice.actions;

export default authSlice.reducer;
